import api from '../../utils/apiFetch';

const path = 'catalog';
export default {
  getTypes: () => api.get(`${path}/types`),
};
